// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a:not([href]):not([class]),
a:not([href]):not([class]):hover {
  color: rgb(2, 19, 126) !important;
}
.css-1hdg57s-MuiTableRow-root td {
  padding: 10px !important;
}
.css-1t48e2w-MuiTableCell-root {
  padding: 10px;
}

.css-lapokc {
  text-overflow: inherit !important;
  text-wrap: wrap !important;
}
.css-1clpn7n-MuiTableCell-root {
  text-overflow: inherit !important;
  text-wrap: wrap !important;
  white-space: pre-wrap !important;
  word-break: break-all !important;
}
`, "",{"version":3,"sources":["webpack://./src/Admin/CommonComps/index.css"],"names":[],"mappings":"AAAA;;EAEE,iCAAiC;AACnC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,gCAAgC;EAChC,gCAAgC;AAClC","sourcesContent":["a:not([href]):not([class]),\r\na:not([href]):not([class]):hover {\r\n  color: rgb(2, 19, 126) !important;\r\n}\r\n.css-1hdg57s-MuiTableRow-root td {\r\n  padding: 10px !important;\r\n}\r\n.css-1t48e2w-MuiTableCell-root {\r\n  padding: 10px;\r\n}\r\n\r\n.css-lapokc {\r\n  text-overflow: inherit !important;\r\n  text-wrap: wrap !important;\r\n}\r\n.css-1clpn7n-MuiTableCell-root {\r\n  text-overflow: inherit !important;\r\n  text-wrap: wrap !important;\r\n  white-space: pre-wrap !important;\r\n  word-break: break-all !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
